import { createSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { getUpcomingInvoice, getUpcomingInvoiceForSubscription } from './upcomingInvoiceActions';
import { IUpcomingInvoice, UpcomingInvoiceliceInitialState } from './upcomingInvoiceTypes';

const initialState: UpcomingInvoiceliceInitialState = {
  upcomingInvoice: {} as IUpcomingInvoice,
  isLoading: false,
};

export const upcomingInvoiceSlice = createSlice({
  name: '@@upcomingInvoice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getUpcomingInvoice.fulfilled, (state, action) => {
      state.upcomingInvoice = action.payload;
      state.isLoading = false;
    });
    builder.addCase(getUpcomingInvoice.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getUpcomingInvoice.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getUpcomingInvoiceForSubscription.fulfilled, (state, action) => {
      state.upcomingInvoice = action.payload;
      state.isLoading = false;
    });
    builder.addCase(getUpcomingInvoiceForSubscription.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getUpcomingInvoiceForSubscription.pending, (state) => {
      state.isLoading = true;
    });
  },
});

export const upcomingInvoiceSelector = createSelector(
  [(state: RootState) => state.upcomingInvoice.upcomingInvoice],
  (info) => info
);

export const isLoadingUpcomingInvoiceSelector = createSelector(
  [(state: RootState) => state.upcomingInvoice.isLoading],
  (info) => info
);
